export const visiblePostsList = (posts = [], visiblePostLimit) => {
    return !!visiblePostLimit && visiblePostLimit < posts.length
        ? posts.slice(0, visiblePostLimit)
        : posts;
};



// WEBPACK FOOTER //
// ./components/post_list/utils.js